import { Component, OnInit } from '@angular/core';
import { ConsoleToggleService } from './global/services/console-toggle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'onboarding';
  constructor(
    private consoleToggleService: ConsoleToggleService
  ){
    this.consoleToggleService.disableConsoleInProduction();
  }
  private constanParams: Array<string> = ['origen', 'run', 'token', 'C'];
  ngOnInit(): void {
    this.rescatarUrl();
  }

  public rescatarUrl() {
    const a = window.location.href.split('?');

    const b = (a[1]) ? a[1].split('&') : [];
    const c = (a[2]) ? a[2].split('&') : [];
    const arrayParams = [...b, ...c];


    arrayParams.forEach(params => {
      const paramsValue = params.split('=');
      if (this.constanParams.includes(paramsValue[0])) {
        localStorage.setItem(paramsValue[0], paramsValue[1]);
      }
    });
  }
}
